import UserFeedbackApi from '@/api/user-feedback'

const state = {
  questions: null,
  questionCode: '',
}

const getters = {
  question(state) {
    return state.questions
  },
  feedbackQuestion(_, getters) {
    return getters.question?.question
  },
  answerOptions(_, getters) {
    return getters.question?.answers || []
  },
}

const mutations = {
  SET_QUESTION_LIST: (state, value) => {
    state.questions = value
  },
  SET_QUESTION_CODE: (state, value) => {
    state.questionCode = value
  },
}

const actions = {
  async fetchFeedbackAnswers({ commit, state }, options) {
    try {
      const questionCode = options?.questionCode ?? ''

      const { data } = await UserFeedbackApi.fetchFeedbackAnswers(options)

      commit('SET_QUESTION_CODE', questionCode)
      commit('SET_QUESTION_LIST', data)

      return data
    } catch (_) {
      commit('SET_QUESTION_LIST', [])
    }
  },
  async submitUserFeedback(
    { commit, rootGetters },
    { answerId, comment, step }
  ) {
    const dataToBeSent = {
      // These are feedback payload
      step,
      answerId,
      comment,
      // These are optional values that are supported for tracking. So we inject here instead of mapping inside component
      orderId: rootGetters.orderId,
      paymentType: rootGetters['session/paymentType'],
    }

    // Inject customer id if user is already logged-in
    if (rootGetters['auth/customerId']) {
      dataToBeSent.customerId = rootGetters['auth/customerId']
    }

    return await UserFeedbackApi.submitFeedback(dataToBeSent)
  },
}

export default { namespaced: true, state, getters, mutations, actions }
